import React, { Component } from 'react';
import { styled } from '@material-ui/core/styles';
import { Box, TextField, MenuItem, RadioGroup, FormControlLabel, Radio, Button } from '@material-ui/core';
import { timeFormat2 } from '../../../../common/utils';
import { ADD, CLIENT, EDIT, VIEW } from '../../../../common/common';
import EditPanel from '../InputsSingle/Panel/EditPanel';

const Root = styled(Box)({
    width: '100%',
    padding: '0 10px',
    '& .panel-wapper-input': {
        width: '100%',
        marginTop: '10px',
        padding: '0 10px',
        minHeight: '200px',
        border: '1px dashed #EAE8EB',
        backgroundColor: '#FAFAFA',
        '& .text-wapper': {
            width: '50%',
            paddingRight: '15px',
            '& .text-field': {
                width: '100%',
                // backgroundColor: '#FFFFFF',
            },
        },
        '& .text-title': {
            marginTop: '10px',
            fontSize: '14px',
            color: '#9B9B9B',
        },
        '& .tool-view': {
            width: '100%',
            padding: '10px 0',
        },
    },
    '& .textWapper': {
        width: '50%',
        paddingRight: '15px',
        '& .textField': {
            width: '100%',
            backgroundColor: '#FFFFFF',
        },
    },
    '& .textTitle': {
        marginTop: '10px',
        fontSize: '14px',
        color: '#9B9B9B',
    },
    '& .itemWapper': {
        width: '100%',
        paddingBottom: '10px',
        borderBottom: '1px dashed #EAE8EB',
    },
})

class Input1 extends Component {
    constructor(props) {
        super(props);
        this.state = {
            dataInfo: {
                "P.F.Name": "",
                "P.L.Name": "",
                "P.DOB": new Date(),
                "P.SSN.L4": "",
                "P.H.Pho": "",
                "P.W.Pho": "",
                "P.Em": "",
                "P.SEX": "",
                "P.F.L.N.I.": "",
                "P.H.Addr": {
                    "phone": "",
                    "unit": "",
                    "street": "",
                    "city": "",
                    "country": "",
                    "state": "",
                    "zipcode": "",
                },
            },
            stateData: ["CN", "US"],
            openPanel: false,
            panelType: "",
            panelId: "",
            isAdd: false
        }
        this.handleChange = this.handleChange.bind(this);
        this.doNext = this.doNext.bind(this);
        this.addInfoData = this.addInfoData.bind(this);
        this.updateInfoData = this.updateInfoData.bind(this);
        this.handleClosePanel = this.handleClosePanel.bind(this);
        this.handleAdd = this.handleAdd.bind(this);
        this.handleEdit = this.handleEdit.bind(this);
    }
    render() {
        const {
            dataInfo,
            stateData,
            openPanel,
            panelType,
            isAdd
        } = this.state;
        const unitView = (key) => {
            if (dataInfo[key]["country"] === "CN") {
                return <div className="text-wapper">
                    <div className="text-title">Principal Unit</div>
                    <div>{dataInfo[key]["unit"]}</div>
                </div>
            }
        }
        const clientView = () => {
            if (dataInfo["P.F.Name"]) {
                return <div className="panel-wapper-input v v-r">
                    <div className="flow">
                        <div className="text-wapper">
                            <div className="text-title">Principal/Client Full Legal Name</div>
                            <div>{dataInfo["P.F.Name"]}</div>
                        </div>
                        <div className="text-wapper">
                            <div className="text-title">Principal/Client Last Name</div>
                            <div>{dataInfo["P.L.Name"]}</div>
                        </div>
                        <div className="text-wapper">
                            <div className="text-title">Principal/Client Initial Name</div>
                            <div>{dataInfo["P.F.L.N.I."]}</div>
                        </div>
                        <div className="text-wapper">
                            <div className="text-title">Principal Gender</div>
                            <div>{dataInfo["P.SEX"]}</div>
                        </div>
                        <div className="text-wapper">
                            <div className="text-title">Principal Date of Birth</div>
                            <div>{timeFormat2(dataInfo["P.DOB"])}</div>
                        </div>
                        <div className="text-wapper">
                            <div className="text-title">Last 4 Digits of Principal Social Security Number</div>
                            <div>{dataInfo["P.SSN.L4"]}</div>
                        </div>
                        <div className="text-wapper">
                            <div className="text-title">Principal Choose The Country</div>
                            <div>{dataInfo["P.H.Addr"]["country"]}</div>
                        </div>
                        {unitView("P.H.Addr")}
                        <div className="text-wapper">
                            <div className="text-title">Principal Street</div>
                            <div>{dataInfo["P.H.Addr"]["street"]}</div>
                        </div>
                        <div className="text-wapper">
                            <div className="text-title">Principal City</div>
                            <div>{dataInfo["P.H.Addr"]["city"]}</div>
                        </div>
                        <div className="text-wapper">
                            <div className="text-title">Principal State</div>
                            <div>{dataInfo["P.H.Addr"]["state"]}</div>
                        </div>
                        <div className="text-wapper">
                            <div className="text-title">Principal Zip Code</div>
                            <div>{dataInfo["P.H.Addr"]["zipcode"]}</div>
                        </div>
                        <div className="text-wapper">
                            <div className="text-title">Principal Home Phone</div>
                            <div>{dataInfo["P.H.Pho"]}</div>
                        </div>
                        <div className="text-wapper">
                            <div className="text-title">Principal Work Phone (Optional)</div>
                            <div>{dataInfo["P.W.Pho"]}</div>
                        </div>
                        <div className="text-wapper">
                            <div className="text-title">Principal Email (Optional)</div>
                            <div>{dataInfo["P.Em"]}</div>
                        </div>
                    </div>
                    <div>
                        <Button size="small" color="primary" onClick={e => this.handleEdit(e, CLIENT)}>Edit</Button>
                    </div>
                </div>
            } else {
                return <div className="panel-wapper-input c">
                    <div className="c">
                        <Button size="small" color="primary" onClick={e => this.handleAdd(e, CLIENT)}>Click Add Principal/Client Info</Button>
                    </div>
                </div>
            }
        }
        return (
            <Root>
                {clientView()}
                <EditPanel
                    open={openPanel}
                    isAdd={isAdd}
                    dataINFO={dataInfo}
                    panelType={panelType}
                    onClose={this.handleClosePanel}
                    updateInfoData={this.updateInfoData}
                    addInfoData={this.addInfoData}
                ></EditPanel>
            </Root>
        )
    }
    componentDidMount() {
        this.initData();
    }
    initData() {
        const { data } = this.props;
        if (!data) return;
        // const dataInfo = this.extractData(data);
        this.setState(() => ({
            dataInfo: data
        }))
    }
    handleAdd(e, type) {
        console.log("点击add", type)
        this.setState({
            panelType: type,
            isAdd: true,
            openPanel: true
        })
    }
    handleEdit(e, type) {
        this.setState({
            panelType: type,
            isAdd: false,
            openPanel: true
        })
    }
    handleClosePanel() {
        this.setState({
            openPanel: false
        })
    }
    addInfoData(panelData) {
        console.log("====panelData====", panelData, "==========")
        this.setDataInfo(panelData, () => {
            this.props.setToAllData("INFO", this.state.dataInfo);
        });
    }
    updateInfoData(panelData) {
        console.log("updateinfo", panelData)
        this.setDataInfo(panelData, () => {
            this.props.setToAllData("INFO", this.state.dataInfo, () => {
                this.props.updateInfoToAllData();
            });
        });
    }
    setDataInfo(panelData, callback = null) {
        const { dataInfo } = this.state;
        for (const key in panelData) {
            if (Object.hasOwnProperty.call(panelData, key)) {
                for (const key2 in dataInfo) {
                    if (Object.hasOwnProperty.call(dataInfo, key2)) {
                        if (key === key2) {
                            dataInfo[key2] = panelData[key];
                        }
                    }
                }
            }
        }
        this.setState({
            dataInfo
        }, () => {
            if (callback) callback();
        });
    }
    extractData(data) {
        let str = data["P.H.Addr"];
        if (str) {
            let strArr = str.split(";");
            if (strArr.length === 6) {
                data["unit"] = strArr[0];
                data["street"] = strArr[1];
                data["city"] = strArr[2];
                data["country"] = strArr[3];
                data["state"] = strArr[4];
                data["zipcode"] = strArr[5];
                return data;
            }
        }
        data["unit"] = "";
        data["street"] = "";
        data["city"] = "";
        data["country"] = "";
        data["state"] = "";
        data["zipcode"] = "";
        return data;
    }
    handleChange(e, name, addrKey) {
        const value = e.target.value;
        const { dataInfo } = this.state;
        dataInfo[name] = value;
        if (name === "phone" || name === "unit"
            || name === "street" || name === "city"
            || name === "country" || name === "state"
            || name === "zipcode") {
            dataInfo[addrKey][name] = value;
        } else if (name === "P.H.Pho") {
            dataInfo["P.H.Addr"]["phone"] = value;
        } else if (name === "P.F.Name") {
            dataInfo["P.L.Name"] = this.splitName(value);
        }
        this.setState(() => ({
            dataInfo
        }));
        this.props.setToAllData("INFO", dataInfo);
    }
    splitName(str) {
        let strArr = str.split(" ");
        if (strArr.length >= 2) {
            return strArr[strArr.length - 1];
        } else {
            return "";
        }
    }
    doNext() {
        const { dataInfo } = this.state;
        let canNext = true;
        for (const key in dataInfo) {
            if (dataInfo.hasOwnProperty(key)) {
                if (key === "P.H.Addr") {
                    canNext = this.verifyAddrValue(dataInfo[key]);
                    if (canNext) {
                        continue;
                    }
                } else if (key === "P.Em" || key === "P.W.Pho") {
                    continue;
                }
                if (dataInfo[key] === "" || canNext === false) {
                    return false;
                }
            }
        }
        return true;
    }
    verifyAddrValue(obj) {
        for (const key in obj) {
            if (obj.hasOwnProperty(key)) {
                if (key === "unit" && obj[key] === "") {
                    if (obj["country"] === "US") {
                        continue;
                    }
                }
                if (key === "phone") {
                    continue;
                }
                if (obj[key] === "") {
                    return false;
                }
            }
        }
        return true;
    }
    getData() {
        return this.state.dataInfo;
    }
    isDisabled() {
        const { state } = this.props;
        if (state === ADD) {
            return false;
        } else if (state === VIEW) {
            return true;
        } else if (state === EDIT) {
            return false;
        }
    }
}

export default Input1;